import { useEffect, useState } from "react";
import { Phone, ChevronRight } from "lucide-react";
import { SITE } from "@/lib/site";

export default function StickyMobileCTA() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // Show after user scrolls past ~70% of hero
      const threshold = Math.max(window.innerHeight * 0.7, 500);
      setShow(window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-mobile-cta"
      aria-hidden={!show}
      className={`md:hidden fixed bottom-0 inset-x-0 z-40 transition-transform duration-500 ease-out ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="bg-black/90 backdrop-blur-xl border-t border-[#2E3036] px-4 py-3 flex items-center gap-3">
        <a
          href={`tel:${SITE.phone.replace(/[^0-9]/g, "")}`}
          data-testid="sticky-mobile-call"
          aria-label={`Call ${SITE.phone}`}
          className="flex items-center justify-center w-12 h-12 border border-[#2E3036] text-[#D4A84B] hover:bg-[#D4A84B]/10 transition-colors flex-shrink-0"
        >
          <Phone className="w-5 h-5" />
        </a>
        <a
          href="#estimate"
          data-testid="sticky-mobile-cta-button"
          className="flex-1 inline-flex items-center justify-center gap-2 bg-[#FFBF00] hover:bg-[#E6AC00] text-[#101010] font-bold py-3 text-sm transition-colors"
        >
          Get Free Estimate
          <ChevronRight className="w-4 h-4" />
        </a>
      </div>
    </div>
  );
}
